import React from "react"
import style from "./style";

const MyConsentsDetailFake = () => {
   return (
    <div className="container my-consents-detail-fake">
      <div className="my-consents-detail-fake--container">
        <div className="skeleton my-consents-detail--title" />
        <div className="skeleton my-consents-detail--desc" />
      </div>
      <style jsx>{style}</style>
    </div>
  );
}

export default MyConsentsDetailFake